// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27m6 8 4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dc-case-form-wrapper {
  background: #f9fafb;
  padding: 2rem;
}
.dc-case-form-wrapper .fetch-details-btn {
  padding: 0.5rem 1rem;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  min-width: 120px;
  transition: background-color 0.2s;
}
.dc-case-form-wrapper .fetch-details-btn:disabled {
  background-color: #9ca3af;
  cursor: not-allowed;
  opacity: 0.6;
}
.dc-case-form-wrapper .fetch-details-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.dc-case-form-wrapper .rem-div-btn,
.dc-case-form-wrapper .add-div-btn {
  display: flex;
  justify-content: flex-end;
  margin-top: 0.5rem;
}
.dc-case-form-wrapper .court-remove-case {
  padding: 0.5rem 1rem;
  background-color: #e74c3c;
  color: white;
  border: none;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
}
.dc-case-form-wrapper .court-remove-case:hover {
  background-color: #dc2626;
}
.dc-case-form-wrapper .court-add-case {
  padding: 0.5rem 1rem;
  background-color: #5cb85c;
  color: white;
  border: none;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
}
.dc-case-form-wrapper .court-add-case:hover {
  background-color: #16a34a;
}
@media (max-width: 768px) {
  .dc-case-form-wrapper {
    padding: 1rem;
  }
}

.court-ref-fetch-section {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 0.375rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  padding: 1.5rem;
  margin: 0 auto 1rem auto;
}
.court-ref-fetch-section .fetch-section-title {
  font-size: 1rem;
  color: #374151;
  font-weight: 500;
  margin: 0 0 1rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e5e7eb;
}
.court-ref-fetch-section .fetch-input-group {
  display: flex;
  gap: 1rem;
  align-items: flex-end;
}
@media (max-width: 768px) {
  .court-ref-fetch-section .fetch-input-group {
    flex-direction: column;
    align-items: stretch;
    gap: 0.75rem;
  }
}
.court-ref-fetch-section .fetch-input-wrapper {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}
.court-ref-fetch-section .fetch-label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  font-size: 0.875rem;
  color: #374151;
}
.court-ref-fetch-section .fetch-input {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-family: inherit;
  color: #374151;
  background: #ffffff;
  box-sizing: border-box;
}
.court-ref-fetch-section .fetch-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.court-ref-fetch-section .fetch-input:hover:not(:focus) {
  border-color: #9ca3af;
}
.court-ref-fetch-section .fetch-input::placeholder {
  color: #9ca3af;
}
.court-ref-fetch-section .fetch-details-btn {
  padding: 0.75rem 1.5rem;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  min-width: 140px;
  transition: background-color 0.2s;
  height: fit-content;
}
.court-ref-fetch-section .fetch-details-btn:hover:not(:disabled) {
  background-color: #0052a3;
}
.court-ref-fetch-section .fetch-details-btn:disabled {
  background-color: #9ca3af;
  cursor: not-allowed;
  opacity: 0.6;
}
.court-ref-fetch-section .fetch-details-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
@media (max-width: 768px) {
  .court-ref-fetch-section .fetch-details-btn {
    width: 100%;
  }
}
@media (max-width: 768px) {
  .court-ref-fetch-section {
    padding: 1rem;
    margin-bottom: 1.5rem;
  }
}

.dc-case-form-header {
  text-align: center;
  margin-bottom: 2rem;
}
.dc-case-form-header .dc-case-form-title {
  font-weight: 500;
  margin-bottom: 0.5rem;
  color: #374151;
  font-size: 1.3rem;
}
@media (max-width: 768px) {
  .dc-case-form-header .dc-case-form-title {
    font-size: 1.25rem;
  }
}
.dc-case-form-header .dc-case-form-subtitle {
  font-size: 0.875rem;
  color: #6b7280;
  font-weight: 400;
}

.dc-case-form {
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 0.375rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin: auto;
}
@media (max-width: 768px) {
  .dc-case-form {
    padding: 1rem;
    margin: 1rem;
  }
}

.dc-section {
  margin-bottom: 1.5rem;
}
.dc-section:last-child {
  margin-bottom: 0;
}

.dc-section-title {
  font-size: 1.1rem;
  font-weight: 500;
  color: #374151;
  margin: 0 0 1rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e5e7eb;
}
@media (max-width: 768px) {
  .dc-section-title {
    font-size: 1rem;
  }
}

.dc-subsection {
  background: #f9fafb;
  border-radius: 0.375rem;
  padding: 1rem;
  margin-bottom: 1rem;
  border: 1px solid #f3f4f6;
  transition: all 0.3s ease-in-out;
}
.dc-subsection.collapsed {
  padding: 0.75rem 1rem;
}
.dc-subsection:last-child {
  margin-bottom: 0;
}
@media (max-width: 768px) {
  .dc-subsection {
    padding: 0.75rem;
  }
}

.summary-view {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 1rem;
}
.summary-view .summary-details {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
  font-size: 0.875rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - 180px);
}
.summary-view .summary-details .summary-item {
  display: flex;
  gap: 0.35rem;
}
.summary-view .summary-details .summary-label {
  color: #6b7280;
  font-weight: 500;
}
.summary-view .summary-details .summary-value {
  color: #111827;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.summary-view .summary-actions {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}
.summary-view .summary-actions .edit-btn {
  padding: 0.5rem 1rem;
  background-color: #3b82f6;
  color: white;
  border: none;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 0.2s;
}
.summary-view .summary-actions .edit-btn:hover {
  background-color: #2563eb;
}

.dc-field-row {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
}
.dc-field-row:last-child {
  margin-bottom: 0;
}
@media (max-width: 768px) {
  .dc-field-row {
    flex-direction: column;
    gap: 0.5rem;
  }
}

.dc-field-group {
  margin-bottom: 1rem;
}
.dc-field-group:last-child {
  margin-bottom: 0;
}

.dc-input-wrapper {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
}
.dc-input-wrapper:last-child {
  margin-bottom: 0;
}

.dc-label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  font-size: 0.875rem;
  color: #374151;
}
.dc-label .user-form-required {
  color: #ef4444;
  margin-left: 0.25rem;
}

.dc-input,
.dc-textarea {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-family: inherit;
  color: #374151;
  background: #ffffff;
  box-sizing: border-box;
}
.dc-input:focus,
.dc-textarea:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.dc-input:hover:not(:focus),
.dc-textarea:hover:not(:focus) {
  border-color: #9ca3af;
}
.dc-input::placeholder,
.dc-textarea::placeholder {
  color: #9ca3af;
}
.dc-input:disabled,
.dc-textarea:disabled {
  background-color: #f9fafb;
  color: #6b7280;
  cursor: not-allowed;
}

.dc-input {
  height: 2.5rem;
}
.dc-input.dc-input-full {
  grid-column: 1/-1;
}
.dc-input.dc-input-date {
  cursor: pointer;
}
.dc-input.dc-input-date::-webkit-calendar-picker-indicator {
  cursor: pointer;
  opacity: 0.6;
}
.dc-input.dc-input-date::-webkit-calendar-picker-indicator:hover {
  opacity: 0.8;
}

select.dc-input {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5rem 1.5rem;
  padding-right: 2.5rem;
}

.dc-textarea {
  min-height: 4rem;
  resize: vertical;
  line-height: 1.5;
  font-family: inherit;
}

.dc-empty-state {
  text-align: center;
  padding: 2rem;
  background: #f9fafb;
  border-radius: 0.375rem;
  border: 2px dashed #e5e7eb;
}

.dc-empty-text {
  color: #6b7280;
  font-style: italic;
  font-size: 0.875rem;
}

.dc-submit-section-form {
  display: flex;
  justify-content: end;
  margin-top: 1.5rem;
  border-top: 1px solid #e5e7eb;
}
@media (max-width: 768px) {
  .dc-submit-section-form {
    flex-direction: column;
  }
}
.dc-submit-section-form .submit-btn {
  padding: 0.75rem 1rem;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 0.25rem;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  min-width: 150px;
  margin-top: 1rem;
  display: block;
}
.dc-submit-section-form .submit-btn:hover {
  background-color: #005a9a;
}
.dc-submit-section-form .submit-btn:focus {
  outline: none;
}
.dc-submit-section-form .submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
@media (max-width: 768px) {
  .dc-submit-section-form .submit-btn {
    width: 100%;
    margin-top: 1rem;
  }
}

.dc-submit-section {
  position: fixed;
  bottom: 2rem;
  left: 87.7%;
  transform: translateX(-145%);
  z-index: 1000;
}
.dc-submit-section.hidden {
  opacity: 0;
  pointer-events: none;
}
@media (max-width: 768px) {
  .dc-submit-section {
    bottom: 1rem;
    left: 1rem;
    right: 1rem;
    transform: none;
  }
}
.dc-submit-section .dc-submit-btn {
  padding: 0.75rem 1rem;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 0.25rem;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  min-width: 150px;
  margin: 1.5rem auto 0;
  display: block;
}
.dc-submit-section .dc-submit-btn:hover {
  background-color: #005a9a;
}
.dc-submit-section .dc-submit-btn:focus {
  outline: none;
}
.dc-submit-section .dc-submit-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}
.dc-submit-section .dc-submit-btn:disabled:hover {
  transform: none;
}
@media (max-width: 768px) {
  .dc-submit-section .dc-submit-btn {
    width: 100%;
    border-radius: 25px;
    min-width: unset;
    font-size: 0.95rem;
    padding: 0.875rem 1.25rem;
  }
}

@media (max-width: 768px) {
  .dc-field-row {
    flex-direction: column;
    gap: 0.5rem;
  }
  .dc-subsection {
    padding: 0.75rem;
  }
  .dc-input,
  .dc-textarea {
    font-size: 0.875rem;
  }
}
@media (max-width: 480px) {
  .dc-case-form-wrapper {
    padding: 0.5rem;
  }
  .dc-case-form {
    padding: 1rem;
    margin: 0.5rem;
  }
  .dc-case-form-header .dc-case-form-title {
    font-size: 1.125rem;
  }
  .dc-input,
  .dc-textarea {
    padding: 0.375rem;
    font-size: 0.8125rem;
  }
  .dc-submit-btn {
    padding: 0.375rem 0.75rem;
    font-size: 0.8125rem;
  }
}
.dc-case-form {
  animation: dc-fade-in 0.3s ease-out;
}

@keyframes dc-fade-in {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media print {
  .dc-case-form-wrapper {
    background: white;
    padding: 0;
  }
  .dc-case-form {
    box-shadow: none;
    border: 1px solid #000;
  }
  .dc-submit-section,
  .rem-div-btn,
  .add-div-btn {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/forms/DistrictCourtCaseForm/DistrictCourtCaseForm.scss"],"names":[],"mappings":"AACA;EAEE,mBAAA;EACA,aAAA;AADF;AAGE;EACE,oBAAA;EACA,sCAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,iCAAA;AADJ;AAGI;EACE,yBAAA;EACA,mBAAA;EACA,YAAA;AADN;AAII;EACE,aAAA;EACA,6CAAA;AAFN;AAME;;EAEE,aAAA;EACA,yBAAA;EACA,kBAAA;AAJJ;AAOE;EACE,oBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AALJ;AAOI;EACE,yBAAA;AALN;AASE;EACE,oBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AAPJ;AASI;EACE,yBAAA;AAPN;AAYE;EApEF;IAqEI,aAAA;EATF;AACF;;AAYA;EACE,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,wCAAA;EACA,eAAA;EACA,wBAAA;AATF;AAWE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gCAAA;AATJ;AAYE;EACE,aAAA;EACA,SAAA;EACA,qBAAA;AAVJ;AAYI;EALF;IAMI,sBAAA;IACA,oBAAA;IACA,YAAA;EATJ;AACF;AAYE;EACE,SAAA;EACA,aAAA;EACA,sBAAA;AAVJ;AAaE;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAXJ;AAcE;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;AAZJ;AAcI;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAZN;AAeI;EACE,qBAAA;AAbN;AAgBI;EACE,cAAA;AAdN;AAkBE;EACE,uBAAA;EACA,sCAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,iCAAA;EACA,mBAAA;AAhBJ;AAkBI;EACE,yBAAA;AAhBN;AAmBI;EACE,yBAAA;EACA,mBAAA;EACA,YAAA;AAjBN;AAoBI;EACE,aAAA;EACA,6CAAA;AAlBN;AAqBI;EA7BF;IA8BI,WAAA;EAlBJ;AACF;AAqBE;EAvGF;IAwGI,aAAA;IACA,qBAAA;EAlBF;AACF;;AAsBA;EACE,kBAAA;EACA,mBAAA;AAnBF;AAqBE;EACE,gBAAA;EACA,qBAAA;EACA,cAAA;EACA,iBAAA;AAnBJ;AAqBI;EANF;IAOI,kBAAA;EAlBJ;AACF;AAqBE;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;AAnBJ;;AAwBA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,wCAAA;EACA,YAAA;AArBF;AAuBE;EAVF;IAWI,aAAA;IACA,YAAA;EApBF;AACF;;AAwBA;EACE,qBAAA;AArBF;AAuBE;EACE,gBAAA;AArBJ;;AAyBA;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,gCAAA;AAtBF;AAwBE;EARF;IASI,eAAA;EArBF;AACF;;AAwBA;EACE,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gCAAA;AArBF;AAwBE;EACE,qBAAA;AAtBJ;AAyBE;EACE,gBAAA;AAvBJ;AA0BE;EAjBF;IAkBI,gBAAA;EAvBF;AACF;;AA2BA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;AAxBF;AA0BE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;EAEA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,6BAAA;AAzBJ;AA2BI;EACI,aAAA;EACA,YAAA;AAzBR;AA4BI;EACE,cAAA;EACA,gBAAA;AA1BN;AA6BI;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA3BN;AA+BE;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AA7BJ;AA+BI;EACE,oBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,iCAAA;AA7BN;AA+BM;EACE,yBAAA;AA7BR;;AAqCA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAlCF;AAoCE;EACE,gBAAA;AAlCJ;AAqCE;EATF;IAUI,sBAAA;IACA,WAAA;EAlCF;AACF;;AAqCA;EACE,mBAAA;AAlCF;AAoCE;EACE,gBAAA;AAlCJ;;AAuCA;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AApCF;AAsCE;EACE,gBAAA;AApCJ;;AAwCA;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AArCF;AAsCE;EACE,cAAA;EACA,oBAAA;AApCJ;;AAwCA;;EAEE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;AArCF;AAuCE;;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AApCJ;AAuCE;;EACE,qBAAA;AApCJ;AAuCE;;EACE,cAAA;AApCJ;AAuCE;;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;AApCJ;;AAwCA;EACE,cAAA;AArCF;AAuCE;EACE,iBAAA;AArCJ;AAwCE;EACE,eAAA;AAtCJ;AAwCI;EACE,eAAA;EACA,YAAA;AAtCN;AAwCM;EACE,YAAA;AAtCR;;AA+CA;EACE,gBAAA;EACA,yDAAA;EACA,wCAAA;EACA,4BAAA;EACA,8BAAA;EACA,qBAAA;AA5CF;;AA+CA;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;AA5CF;;AAgDA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0BAAA;AA7CF;;AAgDA;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;AA7CF;;AAgDA;EACE,aAAA;EACA,oBAAA;EACA,kBAAA;EACA,6BAAA;AA7CF;AA+CE;EANF;IAOI,sBAAA;EA5CF;AACF;AA8CE;EACE,qBAAA;EACA,sCAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AA5CJ;AA8CI;EACE,yBAAA;AA5CN;AAmDI;EACE,aAAA;AAjDN;AAqDI;EACE,YAAA;EACA,mBAAA;AAnDN;AAsDI;EA/BF;IAgCI,WAAA;IACA,gBAAA;EAnDJ;AACF;;AAwDA;EASE,eAAA;EACA,YAAA;EACA,WAAA;EACA,4BAAA;EACA,aAAA;AA7DF;AAgEE;EACE,UAAA;EACA,oBAAA;AA9DJ;AAiEE;EArBF;IAsBI,YAAA;IACA,UAAA;IACA,WAAA;IACA,eAAA;EA9DF;AACF;AAgEE;EACE,qBAAA;EACA,sCAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;AA9DJ;AAgEI;EACE,yBAAA;AA9DN;AAwEI;EACE,aAAA;AAtEN;AA0EI;EACE,YAAA;EACA,mBAAA;EACA,eAAA;AAxEN;AA0EM;EAEE,eAAA;AAzER;AA8EI;EAzCF;IA0CI,WAAA;IACA,mBAAA;IACA,gBAAA;IACA,kBAAA;IACA,yBAAA;EA3EJ;AACF;;AAmHA;EACE;IACE,sBAAA;IACA,WAAA;EAhHF;EAmHA;IACE,gBAAA;EAjHF;EAoHA;;IAEE,mBAAA;EAlHF;AACF;AAqHA;EACE;IACE,eAAA;EAnHF;EAsHA;IACE,aAAA;IACA,cAAA;EApHF;EAuHA;IACE,mBAAA;EArHF;EAwHA;;IAEE,iBAAA;IACA,oBAAA;EAtHF;EAyHA;IACE,yBAAA;IACA,oBAAA;EAvHF;AACF;AA2HA;EACE,mCAAA;AAzHF;;AA4HA;EACE;IACE,UAAA;IACA,2BAAA;EAzHF;EA4HA;IACE,UAAA;IACA,wBAAA;EA1HF;AACF;AA8HA;EACE;IACE,iBAAA;IACA,UAAA;EA5HF;EA+HA;IACE,gBAAA;IACA,sBAAA;EA7HF;EAgIA;;;IAGE,aAAA;EA9HF;AACF","sourcesContent":["// Main Container\r\n.dc-case-form-wrapper {\r\n  // min-height: 100vh;\r\n  background: #f9fafb;\r\n  padding: 2rem;\r\n\r\n  .fetch-details-btn {\r\n    padding: 0.5rem 1rem;\r\n    background-color: var(--primary-color);\r\n    color: white;\r\n    border: none;\r\n    border-radius: 0.25rem;\r\n    font-size: 0.875rem;\r\n    font-weight: 500;\r\n    cursor: pointer;\r\n    white-space: nowrap;\r\n    min-width: 120px;\r\n    transition: background-color 0.2s;\r\n\r\n    &:disabled {\r\n      background-color: #9ca3af;\r\n      cursor: not-allowed;\r\n      opacity: 0.6;\r\n    }\r\n\r\n    &:focus {\r\n      outline: none;\r\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n    }\r\n  }\r\n\r\n  .rem-div-btn,\r\n  .add-div-btn {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    margin-top: 0.5rem;\r\n  }\r\n  \r\n  .court-remove-case {\r\n    padding: 0.5rem 1rem;\r\n    background-color: #e74c3c;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 0.25rem;\r\n    font-size: 0.875rem;\r\n    font-weight: 500;\r\n    cursor: pointer;\r\n\r\n    &:hover {\r\n      background-color: #dc2626;\r\n    }\r\n  }\r\n\r\n  .court-add-case {\r\n    padding: 0.5rem 1rem;\r\n    background-color: #5cb85c;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 0.25rem;\r\n    font-size: 0.875rem;\r\n    font-weight: 500;\r\n    cursor: pointer;\r\n\r\n    &:hover {\r\n      background-color: #16a34a;\r\n    }\r\n  }\r\n\r\n\r\n  @media (max-width: 768px) {\r\n    padding: 1rem;\r\n  }\r\n}\r\n\r\n.court-ref-fetch-section {\r\n  background: #ffffff;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 0.375rem;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n  padding: 1.5rem;\r\n  margin: 0 auto 1rem auto;\r\n\r\n  .fetch-section-title {\r\n    font-size: 1rem;\r\n    color: #374151;\r\n    font-weight: 500;\r\n    margin: 0 0 1rem 0;\r\n    padding-bottom: 0.5rem;\r\n    border-bottom: 1px solid #e5e7eb;\r\n  }\r\n\r\n  .fetch-input-group {\r\n    display: flex;\r\n    gap: 1rem;\r\n    align-items: flex-end;\r\n\r\n    @media (max-width: 768px) {\r\n      flex-direction: column;\r\n      align-items: stretch;\r\n      gap: 0.75rem;\r\n    }\r\n  }\r\n\r\n  .fetch-input-wrapper {\r\n    flex: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n  }\r\n\r\n  .fetch-label {\r\n    display: block;\r\n    margin-bottom: 0.5rem;\r\n    font-weight: 500;\r\n    font-size: 0.875rem;\r\n    color: #374151;\r\n  }\r\n\r\n  .fetch-input {\r\n    width: 100%;\r\n    padding: 0.75rem;\r\n    border: 1px solid #d1d5db;\r\n    border-radius: 0.25rem;\r\n    font-size: 0.875rem;\r\n    font-family: inherit;\r\n    color: #374151;\r\n    background: #ffffff;\r\n    box-sizing: border-box;\r\n\r\n    &:focus {\r\n      outline: none;\r\n      border-color: #3b82f6;\r\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n    }\r\n\r\n    &:hover:not(:focus) {\r\n      border-color: #9ca3af;\r\n    }\r\n\r\n    &::placeholder {\r\n      color: #9ca3af;\r\n    }\r\n  }\r\n\r\n  .fetch-details-btn {\r\n    padding: 0.75rem 1.5rem;\r\n    background-color: var(--primary-color);\r\n    color: white;\r\n    border: none;\r\n    border-radius: 0.25rem;\r\n    font-size: 0.875rem;\r\n    font-weight: 500;\r\n    cursor: pointer;\r\n    white-space: nowrap;\r\n    min-width: 140px;\r\n    transition: background-color 0.2s;\r\n    height: fit-content;\r\n\r\n    &:hover:not(:disabled) {\r\n      background-color: #0052a3;\r\n    }\r\n\r\n    &:disabled {\r\n      background-color: #9ca3af;\r\n      cursor: not-allowed;\r\n      opacity: 0.6;\r\n    }\r\n\r\n    &:focus {\r\n      outline: none;\r\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n    }\r\n\r\n    @media (max-width: 768px) {\r\n      width: 100%;\r\n    }\r\n  }\r\n\r\n  @media (max-width: 768px) {\r\n    padding: 1rem;\r\n    margin-bottom: 1.5rem;\r\n  }\r\n}\r\n\r\n// Header Section\r\n.dc-case-form-header {\r\n  text-align: center;\r\n  margin-bottom: 2rem;\r\n\r\n  .dc-case-form-title {\r\n    font-weight: 500;\r\n    margin-bottom: 0.5rem;\r\n    color: #374151;\r\n    font-size: 1.3rem;\r\n\r\n    @media (max-width: 768px) {\r\n      font-size: 1.25rem;\r\n    }\r\n  }\r\n\r\n  .dc-case-form-subtitle {\r\n    font-size: 0.875rem;\r\n    color: #6b7280;\r\n    font-weight: 400;\r\n  }\r\n}\r\n\r\n// Form Container\r\n.dc-case-form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 1.5rem;\r\n  background-color: #ffffff;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 0.375rem;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n  margin: auto;\r\n\r\n  @media (max-width: 768px) {\r\n    padding: 1rem;\r\n    margin: 1rem;\r\n  }\r\n}\r\n\r\n// Section Styling\r\n.dc-section {\r\n  margin-bottom: 1.5rem;\r\n\r\n  &:last-child {\r\n    margin-bottom: 0;\r\n  }\r\n}\r\n\r\n.dc-section-title {\r\n  font-size: 1.1rem;\r\n  font-weight: 500;\r\n  color: #374151;\r\n  margin: 0 0 1rem 0;\r\n  padding-bottom: 0.5rem;\r\n  border-bottom: 1px solid #e5e7eb;\r\n\r\n  @media (max-width: 768px) {\r\n    font-size: 1rem;\r\n  }\r\n}\r\n\r\n.dc-subsection {\r\n  background: #f9fafb;\r\n  border-radius: 0.375rem;\r\n  padding: 1rem;\r\n  margin-bottom: 1rem;\r\n  border: 1px solid #f3f4f6;\r\n  transition: all 0.3s ease-in-out; // <-- Added transition\r\n\r\n  // <-- Added collapsed state -->\r\n  &.collapsed {\r\n    padding: 0.75rem 1rem;\r\n  }\r\n  \r\n  &:last-child {\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  @media (max-width: 768px) {\r\n    padding: 0.75rem;\r\n  }\r\n}\r\n\r\n// <-- ADD THIS ENTIRE BLOCK -->\r\n.summary-view {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  width: 100%;\r\n  gap: 1rem;\r\n\r\n  .summary-details {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 1rem;\r\n    flex-wrap: wrap;\r\n    font-size: 0.875rem;\r\n    // For single-line text summaries\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    max-width: calc(100% - 180px); // Adjust based on button widths\r\n\r\n    .summary-item {\r\n        display: flex;\r\n        gap: 0.35rem;\r\n    }\r\n\r\n    .summary-label {\r\n      color: #6b7280;\r\n      font-weight: 500;\r\n    }\r\n\r\n    .summary-value {\r\n      color: #111827;\r\n      font-weight: 400;\r\n      white-space: nowrap;\r\n      overflow: hidden;\r\n      text-overflow: ellipsis;\r\n    }\r\n  }\r\n\r\n  .summary-actions {\r\n    display: flex;\r\n    gap: 0.5rem;\r\n    align-items: center;\r\n    \r\n    .edit-btn {\r\n      padding: 0.5rem 1rem;\r\n      background-color: #3b82f6;\r\n      color: white;\r\n      border: none;\r\n      border-radius: 0.25rem;\r\n      font-size: 0.875rem;\r\n      font-weight: 500;\r\n      cursor: pointer;\r\n      white-space: nowrap;\r\n      transition: background-color 0.2s;\r\n\r\n      &:hover {\r\n        background-color: #2563eb;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n\r\n// Field Layout\r\n.dc-field-row {\r\n  display: flex;\r\n  gap: 1rem;\r\n  margin-bottom: 1rem;\r\n\r\n  &:last-child {\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  @media (max-width: 768px) {\r\n    flex-direction: column;\r\n    gap: 0.5rem;\r\n  }\r\n}\r\n\r\n.dc-field-group {\r\n  margin-bottom: 1rem;\r\n\r\n  &:last-child {\r\n    margin-bottom: 0;\r\n  }\r\n}\r\n\r\n// Input Styling\r\n.dc-input-wrapper {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin-bottom: 1rem;\r\n\r\n  &:last-child {\r\n    margin-bottom: 0;\r\n  }\r\n}\r\n\r\n.dc-label {\r\n  display: block;\r\n  margin-bottom: 0.5rem;\r\n  font-weight: 500;\r\n  font-size: 0.875rem;\r\n  color: #374151;\r\n  .user-form-required {\r\n    color: #ef4444;\r\n    margin-left: 0.25rem;\r\n  }\r\n}\r\n\r\n.dc-input,\r\n.dc-textarea {\r\n  width: 100%;\r\n  padding: 0.5rem;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 0.25rem;\r\n  font-size: 0.875rem;\r\n  font-family: inherit;\r\n  color: #374151;\r\n  background: #ffffff;\r\n  box-sizing: border-box;\r\n\r\n  &:focus {\r\n    outline: none;\r\n    border-color: #3b82f6;\r\n    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n  }\r\n\r\n  &:hover:not(:focus) {\r\n    border-color: #9ca3af;\r\n  }\r\n\r\n  &::placeholder {\r\n    color: #9ca3af;\r\n  }\r\n\r\n  &:disabled {\r\n    background-color: #f9fafb;\r\n    color: #6b7280;\r\n    cursor: not-allowed;\r\n  }\r\n}\r\n\r\n.dc-input {\r\n  height: 2.5rem;\r\n\r\n  &.dc-input-full {\r\n    grid-column: 1 / -1;\r\n  }\r\n\r\n  &.dc-input-date {\r\n    cursor: pointer;\r\n\r\n    &::-webkit-calendar-picker-indicator {\r\n      cursor: pointer;\r\n      opacity: 0.6;\r\n\r\n      &:hover {\r\n        opacity: 0.8;\r\n      }\r\n    }\r\n  }\r\n\r\n  // Select styling removed from here - moved below\r\n}\r\n\r\n// Select styling\r\nselect.dc-input {\r\n  appearance: none;\r\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\");\r\n  background-position: right 0.5rem center;\r\n  background-repeat: no-repeat;\r\n  background-size: 1.5rem 1.5rem;\r\n  padding-right: 2.5rem;\r\n}\r\n\r\n.dc-textarea {\r\n  min-height: 4rem;\r\n  resize: vertical;\r\n  line-height: 1.5;\r\n  font-family: inherit;\r\n}\r\n\r\n// Empty State\r\n.dc-empty-state {\r\n  text-align: center;\r\n  padding: 2rem;\r\n  background: #f9fafb;\r\n  border-radius: 0.375rem;\r\n  border: 2px dashed #e5e7eb;\r\n}\r\n\r\n.dc-empty-text {\r\n  color: #6b7280;\r\n  font-style: italic;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.dc-submit-section-form {\r\n  display: flex;\r\n  justify-content: end;\r\n  margin-top: 1.5rem;\r\n  border-top: 1px solid #e5e7eb;\r\n\r\n  @media (max-width: 768px) {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .submit-btn {\r\n    padding: 0.75rem 1rem;\r\n    background-color: var(--primary-color);\r\n    color: white;\r\n    border: none;\r\n    border-radius: 0.25rem;\r\n    font-size: 1rem;\r\n    font-weight: 500;\r\n    cursor: pointer;\r\n    min-width: 150px;\r\n    margin-top: 1rem;\r\n    display: block;\r\n\r\n    &:hover {\r\n      background-color: #005a9a;\r\n    }\r\n\r\n    // &:active {\r\n    //   transform: translateY(1px);\r\n    // }\r\n\r\n    &:focus {\r\n      outline: none;\r\n      //box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.3);\r\n    }\r\n\r\n    &:disabled {\r\n      opacity: 0.6;\r\n      cursor: not-allowed;\r\n    }\r\n\r\n    @media (max-width: 768px) {\r\n      width: 100%;\r\n      margin-top: 1rem;\r\n    }\r\n  }\r\n}\r\n\r\n// Submit Section\r\n.dc-submit-section {\r\n  // display: flex;\r\n  // justify-content: center;\r\n  // margin-top: 1.5rem;\r\n  // border-top: 1px solid #e5e7eb;\r\n\r\n  // @media (max-width: 768px) {\r\n  //   flex-direction: column;\r\n  // }\r\n  position: fixed;\r\n  bottom: 2rem;\r\n  left: 87.7%;\r\n  transform: translateX(-145%);\r\n  z-index: 1000;\r\n\r\n  //transition: opacity 0.3s ease; // Added transition for smooth hiding\r\n  &.hidden {\r\n    opacity: 0;\r\n    pointer-events: none;\r\n  }\r\n\r\n  @media (max-width: 768px) {\r\n    bottom: 1rem;\r\n    left: 1rem;\r\n    right: 1rem;\r\n    transform: none;\r\n  }\r\n\r\n  .dc-submit-btn {\r\n    padding: 0.75rem 1rem;\r\n    background-color: var(--primary-color);\r\n    color: white;\r\n    border: none;\r\n    border-radius: 0.25rem;\r\n    font-size: 1rem;\r\n    font-weight: 500;\r\n    cursor: pointer;\r\n    min-width: 150px;\r\n    margin: 1.5rem auto 0;\r\n    display: block;\r\n\r\n    &:hover {\r\n      background-color: #005a9a;\r\n      //box-shadow: 0 6px 20px rgba(92, 184, 92, 0.4);\r\n      // transform: translateY(-2px);\r\n    }\r\n\r\n    &:active {\r\n      //transform: translateY(0);\r\n      //box-shadow: 0 2px 8px rgba(92, 184, 92, 0.3);\r\n    }\r\n\r\n    &:focus {\r\n      outline: none;\r\n      //box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.3), 0 4px 12px rgba(92, 184, 92, 0.3);\r\n    }\r\n\r\n    &:disabled {\r\n      opacity: 0.7;\r\n      cursor: not-allowed;\r\n      transform: none;\r\n\r\n      &:hover {\r\n        //background-color: #5cb85c;\r\n        transform: none;\r\n        //box-shadow: 0 4px 12px rgba(92, 184, 92, 0.3);\r\n      }\r\n    }\r\n\r\n    @media (max-width: 768px) {\r\n      width: 100%;\r\n      border-radius: 25px;\r\n      min-width: unset;\r\n      font-size: 0.95rem;\r\n      padding: 0.875rem 1.25rem;\r\n    }\r\n  }\r\n}\r\n\r\n// .dc-submit-btn {\r\n//   padding: 1rem 1.5rem;\r\n//   background-color: #5cb85c;\r\n//   color: white;\r\n//   border: none;\r\n//   border-radius: 0.25rem;\r\n//   font-size: 1rem;\r\n//   font-weight: 500;\r\n//   cursor: pointer;\r\n//   min-width: 150px;\r\n//   margin: 1.5rem auto 0;\r\n\r\n//   &:hover {\r\n//     background-color: #16a34a;\r\n//   }\r\n\r\n//   &:active {\r\n//     transform: translateY(1px);\r\n//   }\r\n\r\n//   &:focus {\r\n//     outline: none;\r\n//     box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.3);\r\n//   }\r\n\r\n//   &:disabled {\r\n//     opacity: 0.6;\r\n//     cursor: not-allowed;\r\n//   }\r\n\r\n//   @media (max-width: 768px) {\r\n//     width: 100%;\r\n//   }\r\n// }\r\n\r\n// Responsive Design\r\n@media (max-width: 768px) {\r\n  .dc-field-row {\r\n    flex-direction: column;\r\n    gap: 0.5rem;\r\n  }\r\n\r\n  .dc-subsection {\r\n    padding: 0.75rem;\r\n  }\r\n\r\n  .dc-input,\r\n  .dc-textarea {\r\n    font-size: 0.875rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .dc-case-form-wrapper {\r\n    padding: 0.5rem;\r\n  }\r\n\r\n  .dc-case-form {\r\n    padding: 1rem;\r\n    margin: 0.5rem;\r\n  }\r\n\r\n  .dc-case-form-header .dc-case-form-title {\r\n    font-size: 1.125rem;\r\n  }\r\n\r\n  .dc-input,\r\n  .dc-textarea {\r\n    padding: 0.375rem;\r\n    font-size: 0.8125rem;\r\n  }\r\n\r\n  .dc-submit-btn {\r\n    padding: 0.375rem 0.75rem;\r\n    font-size: 0.8125rem;\r\n  }\r\n}\r\n\r\n// Animation for form appearance\r\n.dc-case-form {\r\n  animation: dc-fade-in 0.3s ease-out;\r\n}\r\n\r\n@keyframes dc-fade-in {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(10px);\r\n  }\r\n\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n// Print styles\r\n@media print {\r\n  .dc-case-form-wrapper {\r\n    background: white;\r\n    padding: 0;\r\n  }\r\n\r\n  .dc-case-form {\r\n    box-shadow: none;\r\n    border: 1px solid #000;\r\n  }\r\n\r\n  .dc-submit-section,\r\n  .rem-div-btn,\r\n  .add-div-btn {\r\n    display: none;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
